import { useReducedMotionConfig } from "framer-motion";
import { useEffect, useState } from "react";
import { getRouteAnimationFrame, type RouteAnimationFrame } from "../_helpers/route-animation";

export function useRouteAnimationFrame(): RouteAnimationFrame | null {
  const isReducedMotion = useReducedMotionConfig() === true;
  const [animationFrame, setAnimationFrame] = useState(() => getRouteAnimationFrame(0));

  useEffect(() => {
    if (isReducedMotion) {
      return;
    }

    let startTimestamp: number | null = null;
    let requestId = 0;

    const renderFrame = (timestamp: number) => {
      startTimestamp ??= timestamp;
      setAnimationFrame(getRouteAnimationFrame(timestamp - startTimestamp));
      requestId = requestAnimationFrame(renderFrame);
    };

    requestId = requestAnimationFrame(renderFrame);

    return () => cancelAnimationFrame(requestId);
  }, [isReducedMotion]);

  return isReducedMotion ? null : animationFrame;
}
